export class Tenant {
    name: string;
    domainUrl: string;
    language: "EN" | "NL";
    appName: string;
}
